
































































import store, { BankRemitStore } from "../services/BankRemitStore";
import api from "../services/BankRemitApi";
import Vue from "vue";
import eventBus from "@/services/eventBus";
import http, { baseURL } from "@/services/http";

export enum BankRemitStatusEnum {
  underProcess = 2,
  forwardable = 3,
  forwarded = 4,
  transferred = 5,
  failed = 6,
  underRepair = 7,
  partlyTransferred = 8,
}

interface Data {
  store: BankRemitStore;
  selExportType: string;
  exportTypes: string[];
  downloadButtonAvaliable: boolean;
}

interface Method {
  exportRemit(): void;
  downloadRemit(): void;
}

interface Computed {
  exportEnabled: boolean;
  downloadEnabled: boolean;
  exported: boolean;
}

export default Vue.extend<Data, Method, Computed, {}>({
  data() {
    return {
      store,
      selExportType: "",
      exportTypes: [],
      downloadButtonAvaliable: false,
    };
  },

  computed: {
    exportEnabled() {
      return this.store.bankRemit.status === BankRemitStatusEnum.forwardable;
    },
    downloadEnabled() {
      return this.store.bankRemit.status === BankRemitStatusEnum.forwarded;
    },
    exported() {
      return this.store.bankRemit.status === BankRemitStatusEnum.forwarded;
    },
  },

  methods: {
    async exportRemit() {
      const x = await api
        .generatePackage(this.store.bankRemit, this.selExportType)
        .then(async (f) => {
          await this.store.loadBankRemit(this.store.bankRemit.id);
          return true;
        });
      if (x) {
        eventBus.$emit("success", "Sikeres fájlgenerálás!");
      }
    },
    async downloadRemit() {
      const file = await api.getFile(this.store.bankRemit.id);

      const a = document.createElement("a");
      a.href = "data:application/octet-stream;base64," + file.file;
      a.download = file.filename;
      a.click();
    }
  },

  async beforeMount() {
    this.store.step = 4;

    await this.store.loadBankRemit(Number(this.$route.params.id));

    if (this.exportEnabled) {
      this.exportTypes = await api
        .getExportTypes(this.store.bankRemit.id)
        .then((x) => {
          this.selExportType = x[0];
          return x;
        });
    }
  },
});
